export const sortPeople = (people) => {
  if (!Array.isArray(people)) {
    return [];
  }
  
  return people.sort((a, b) => {
    if (a.lastName === b.lastName) {
      return a.firstName.localeCompare(b.firstName);
    }
    return a.lastName.localeCompare(b.lastName);
  });
};